import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";

// variant: "dark" (light text on dark bg) | "light" (steel text on light bg)
export function FooterLinks({ variant = "dark", className = "" }) {
  const { t } = useI18n();
  const base = variant === "dark" ? "text-lc-fog hover:text-white" : "text-lc-steel hover:text-lc-ink";
  const sep = variant === "dark" ? "text-white/20" : "text-lc-ink/20";
  const links = [
    { to: "/resources", label: t("foot.resources"), tid: "footer-resources" },
    { to: "/terms", label: t("foot.terms"), tid: "footer-terms" },
    { to: "/privacy", label: t("foot.privacy"), tid: "footer-privacy" },
    { to: "/about", label: t("foot.about"), tid: "footer-about" },
    { to: "/contact", label: t("foot.contact"), tid: "footer-contact" },
    { to: "/security", label: t("foot.security"), tid: "footer-security" },
    { to: "/guarantee", label: "Guarantee", tid: "footer-guarantee" },
  ];
  return (
    <div className={`flex flex-wrap items-center gap-x-3 gap-y-1 ${className}`} data-testid="footer-links">
      {links.map((l, i) => (
        <span key={l.to} className="inline-flex items-center gap-3">
          {i > 0 && <span className={sep}>|</span>}
          <Link to={l.to} data-testid={l.tid}
            className={`text-xs font-medium transition-colors duration-200 ${base}`}>
            {l.label}
          </Link>
        </span>
      ))}
      <span className="inline-flex items-center gap-3">
        <span className={sep}>|</span>
        <a href="mailto:support@getlcshield.com" data-testid="footer-support"
          className={`text-xs font-medium transition-colors duration-200 ${base}`}>
          support@getlcshield.com
        </a>
      </span>
      <span className="basis-full" />
      <div data-testid="footer-disclaimer" className={`flex flex-col gap-0.5 text-[11px] ${variant === "dark" ? "text-lc-steel" : "text-lc-ink/60"}`}>
        <span>
          A product of DZent Limited (Hong Kong) ·{" "}
          <a href="https://dzentlimited.com" target="_blank" rel="noopener noreferrer" data-testid="footer-dzent-link"
            className={`underline ${variant === "dark" ? "hover:text-white" : "hover:text-lc-ink"}`}>dzentlimited.com</a>
        </span>
        <span>© 2026 DZent Limited (Hong Kong)</span>
        <span>LC Shield is an independent tool and is not affiliated with or endorsed by the ICC.</span>
      </div>
    </div>
  );
}

// Soft clickwrap notice with inline Terms + Privacy links.
export function AgreeNote({ prefix, variant = "light", className = "", testid = "agree-note" }) {
  const { t } = useI18n();
  const muted = variant === "dark" ? "text-lc-fog" : "text-lc-steel";
  const link = variant === "dark" ? "text-lc-sky hover:text-white underline" : "text-lc-ocean hover:text-lc-navy underline";
  return (
    <p data-testid={testid} className={`text-[11px] leading-relaxed ${muted} ${className}`}>
      {prefix}{" "}
      <Link to="/terms" data-testid={`${testid}-terms`} className={`transition-colors duration-200 ${link}`}>{t("agree.terms")}</Link>
      {" "}{t("agree.and")}{" "}
      <Link to="/privacy" data-testid={`${testid}-privacy`} className={`transition-colors duration-200 ${link}`}>{t("agree.privacy")}</Link>.
    </p>
  );
}
